import datePickerComponent from './datePicker.component';
import datePickerFactory from './datePicker.factory';

const datePickerModule = angular.module('app.common.ertDatePicker', [])
	.component('ertDatePicker', datePickerComponent)
	.factory('datePickerService', datePickerFactory)
	.name;

export default datePickerModule;
